<style>
/* Show overflow content to keep customer action dropdown visible */
.customer-list-table .table-wrapper {
  overflow-y: visible;
}
</style>

<template>
  <div>
    <table-filter
      :filterComponents="[
        {
          type: 'TakeFilter',
          name: 'take'
        },
        {
          type: 'WhereFilter',
          label: 'ID',
          attributes: 'id'
        },
        {
          type: 'WhereLikeFilter',
          label: 'E-Mail-Adresse',
          attributes: 'user.email'
        },
        {
          type: 'WhereLikeFilter',
          label: 'Name',
          attributes: 'name'
        },
        {
          type: 'DateFilter',
          label: 'Registrierdatum von',
          attributes: { column: 'created_at', operator: '>=' }
        },
        {
          type: 'DateFilter',
          label: 'Registrierdatum bis',
          attributes: { column: 'created_at', operator: '<=' }
        },
        {
          type: 'CheckboxFilter',
          label: 'Mögliche Dublicate',
          name: 'display_dublicates'
        }
      ]"
      v-model="filter"
      @apply-filters="$bus.$emit('refresh-table')"
    ></table-filter>
    <v-table
      class="customer-list-table"
      url="/api/v1/customerProfile"
      :filter="filter"
      :appends="[
        'user.registered_with_ip_and_country',
        'total_revenu',
        'ins_outs',
        'balance',
        'last_login_at',
        'last_seen_at',
        'last_seen_on'
      ]"
      :row-classes="{
        'table-disabled': model => {
          return Boolean(model.user.disabled_at);
        },
        'table-deleted': model => {
          return Boolean(model.deleted_at);
        },
        'table-deletion': model => {
          return Boolean(model.user.deletion_at);
        }
      }"
      :attributes="[
        {
          attribute: 'id',
          name: 'ID'
        },
        {
          attribute: 'name',
          type: 'LinkProfileCell',
          name: 'Mitglied'
        },
        {
          attribute: 'user.email',
          name: 'E-Mail-Adresse',
          sortable: false
        },
        {
          attribute: 'country',
          name: 'Herkunft',
          type: 'CustomerOriginAndIpCell',
          sortable: false
        },
        {
          attribute: 'created_at',
          name: 'Registert am',
          type: 'DateTimeCell'
        },
        {
          name: 'Online',
          type: 'OnlineVerifiedCell'
        },
        {
          html: true,
          name: euro,
          centered: true,
          attribute: 'total_revenu',
          type: 'CurrencyCell',
          sortable: false
        },
        {
          html: true,
          name: balance,
          centered: true,
          attribute: 'balance',
          type: 'BalanceCell',
          sortable: false
        },
        {
          name: 'In/Out',
          type: 'CustomerInOutCell',
          sortable: false
        },
        {
          attribute: 'last_seen_at',
          name: 'Letzte Seite',
          type: 'LastPageCell'
        },
        {
          name: 'Aktionen',
          type: 'CustomerActionCell'
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
export default {
  data () {
    return {
      filter: [
        {
          name: 'customer',
        }
      ],
      euro: '<i class="fas fa-euro-sign"></i>',
      balance: '<i class="fas fa-money-bill-alt"></i>'
    };
  }
};
</script>
